import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import StoryPage from './StoryPage';

const AdminStoryV2Page = () => {
  const { user } = useAuth();
  const isAdmin = user?.is_admin || user?.email === 'contact@dismaman.com';

  if (!isAdmin) return <Navigate to="/chat" replace />;

  return (
    <div data-testid="admin-story-v2-page">
      <div
        className="fixed top-0 left-0 right-0 z-40 text-center py-1 text-xs font-bold text-white tracking-wider"
        style={{ background: 'linear-gradient(135deg, #8B5CF6, #6D28D9)' }}
      >
        STORY V2 — ADMIN ONLY
      </div>
      <StoryPage apiEndpoint="/admin/stories/generate-v2" />
    </div>
  );
};

export default AdminStoryV2Page;
